import type { UserProfile } from '../services/authService';

export const getUserDisplayIdentifier = (
  user: Pick<UserProfile, 'email' | 'username'> | null | undefined,
): string => user?.email || user?.username || '';
